import { useEffect, useRef } from 'react';
import { Box, IconButton } from '@mui/material';

export default function HeroPanelFrame({ children, titleId, closeLabel, onClose, scrollable = true, sx = {} }) {
  const closeRef = useRef(null);
  const closeAction = useRef(onClose);
  closeAction.current = onClose;

  useEffect(() => {
    const previousFocus = document.activeElement;
    closeRef.current?.focus({ preventScroll: true });
    const handleKey = (event) => {
      if (event.key === 'Escape') closeAction.current();
    };
    window.addEventListener('keydown', handleKey);
    return () => {
      window.removeEventListener('keydown', handleKey);
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    };
  }, []);

  return (
    <Box component="section" aria-labelledby={titleId} sx={{
      position: 'relative', p: { xs: 3, sm: 4, lg: 5 }, pt: { xs: 6, lg: 6 },
      boxSizing: 'border-box', width: '100%', minWidth: 0,
      ...(scrollable ? {
        maxHeight: 'calc(100vh - var(--public-header-height, 172px) - 64px)',
        '@supports (height: 100svh)': { maxHeight: 'calc(100svh - var(--public-header-height, 172px) - 64px)' },
        overflowY: 'auto', overscrollBehavior: 'contain', scrollbarWidth: 'thin'
      } : { maxHeight: 'none', overflow: 'visible' }),
      borderRadius: 5, color: '#142b27', bgcolor: 'rgba(232,235,233,.78)',
      backdropFilter: 'blur(22px)', border: '1px solid rgba(255,255,255,.65)',
      boxShadow: '0 24px 70px rgba(0,0,0,.18)',
      '@keyframes aboutEnter': { from: { opacity: 0, transform: 'translateX(24px)' }, to: { opacity: 1, transform: 'translateX(0)' } },
      animation: 'aboutEnter .4s ease both',
      '@media (prefers-reduced-motion: reduce)': { animation: 'none' },
      ...sx
    }}>
      <IconButton ref={closeRef} onClick={onClose} aria-label={closeLabel}
        sx={{ position: 'absolute', top: 8, right: 8, color: 'inherit', fontSize: 30 }}>×</IconButton>
      {children}
    </Box>
  );
}
